import Notification from './Notification';
import NotificationContent from './NotificationContent';
import NotificationInfo from './NotificationInfo';
import NotificationMessage from './NotificationMessage';
import NotificationInfoRight from './NotificationInfoRight';
import NotificationInfoLeft from './NotificationInfoLeft';

Notification.Content = NotificationContent;
Notification.Info = NotificationInfo;
Notification.InfoRight = NotificationInfoRight;
Notification.InfoLeft = NotificationInfoLeft;
Notification.Message = NotificationMessage;

export { Notification };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Notification/index.js
// module id = 300
// module chunks = 0